import { render, staticRenderFns } from "./techSupport.vue?vue&type=template&id=cb537c92&scoped=true&"
import script from "./techSupport.vue?vue&type=script&lang=js&"
export * from "./techSupport.vue?vue&type=script&lang=js&"
import style0 from "./techSupport.vue?vue&type=style&index=0&id=cb537c92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb537c92",
  null
  
)

export default component.exports